import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

/* ===========================================================
   PROFILE APIS
===========================================================*/

// 🔹 Add / Update Profile
export async function addOrUpdateProfile(profileData) {
  try {
    console.log("sadas",profileData);
    const fd = new FormData();
    fd.append("profile_data", btoa(unescape(encodeURIComponent(JSON.stringify(profileData)))));
    

    const response = await axios.post(
      `${apiBaseUrl}profile/add_update_profile`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("addOrUpdateProfile error:", error);
    return { status: false, type: "danger", success: "Failed to save profile" };
  }
}

export async function submitLead(fdData) {
  try {

    const fd = new FormData();
    fd.append("lead_data", fdData);

    const response = await axios.post(
      `${apiBaseUrl}website/new_lead`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );

    return response.data;

  } catch (error) {

    console.error("submitLead error:", error);

    return {
      status: false,
      type: "danger",
      msg: "Failed to submit lead"
    };

  }
}


// 🔹 Get Profiles (Paginated)
export async function getProfiles(profile_user,page_no = 0,search_key) {
  try {
    const fd = new FormData();
    fd.append("page_no", page_no);
    fd.append("profile_user", profile_user);
    fd.append("search_key", search_key);

    const response = await axios.post(
      `${apiBaseUrl}profile/get_profiles`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("getProfiles error:", error);
    return { status: false, type: "danger", success: "Failed to load profiles" };
  }
}

// 🔹 Get Profile by User ID
export async function getProfileByUserId(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const response = await axios.post(
      `${apiBaseUrl}profile/get_profile_by_user_id`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("getProfileByUserId error:", error);
    return { status: false, type: "danger", success: "Failed to load profile" };
  }
}

// 🔹 Delete Profile
export async function deleteProfile(profile_id) {
  try {
    const fd = new FormData();
    fd.append("profile_id", profile_id);

    const response = await axios.post(
      `${apiBaseUrl}profile/delete_profile`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("deleteProfile error:", error);
    return { status: false, type: "danger", success: "Failed to delete profile" };
  }
}


/* ===========================================================
   MEDIA APIS
===========================================================*/

// 🔹 Add / Update Media
export async function addOrUpdateMedia(formObj) {
  try {
    const fd = new FormData();
    Object.entries(formObj).forEach(([k, v]) => {
      if (v !== null && v !== undefined) fd.append(k, v);
    });

    const response = await axios.post(
      `${apiBaseUrl}profile/media_add_update`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("addOrUpdateMedia error:", error);
    return { status: false, type: "danger", success: "Failed to save media" };
  }
}

// 🔹 Delete Media
export async function deleteMedia(media_id) {
  try {
    const fd = new FormData();
    fd.append("media_id", media_id);

    const response = await axios.post(
      `${apiBaseUrl}profile/media_delete`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("deleteMedia error:", error);
    return { status: false, type: "danger", success: "Failed to delete media" };
  }
}

// 🔹 Media List (Paginated)
export async function getMediaList(media_profile, page_no = 0) {
  try {
    const fd = new FormData();
    fd.append("media_profile", media_profile);
    fd.append("page_no", page_no);

    const response = await axios.post(
      `${apiBaseUrl}profile/media_list`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("getMediaList error:", error);
    return { status: false, type: "danger", success: "Failed to load media" };
  }
}


/* ===========================================================
   REVIEW APIS
===========================================================*/

// 🔹 Add Review
export async function addReview(reviewObj) {
  try {
    const fd = new FormData();
    Object.entries(reviewObj).forEach(([k, v]) => {
      fd.append(k, v);
    });

    const response = await axios.post(
      `${apiBaseUrl}profile/review_add`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("addReview error:", error);
    return { status: false, type: "danger", success: "Failed to add review" };
  }
}

// 🔹 Review List (Paginated)
export async function getReviewList(review_profile, page_no = 0) {
  try {
    const fd = new FormData();
    fd.append("review_profile", review_profile);
    fd.append("page_no", page_no);

    const response = await axios.post(
      `${apiBaseUrl}profile/review_list`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("getReviewList error:", error);
    return { status: false, type: "danger", success: "Failed to load reviews" };
  }
}


// 🔹 Add or Update FAQ
export async function addOrUpdateFAQ(faqData) {
  try {
    const fd = new FormData();
    Object.keys(faqData).forEach(k => fd.append(k, faqData[k]));

    const res = await axios.post(`${apiBaseUrl}profile/faq_add_update`, fd, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    return res.data;
  } catch (error) {
    console.error("addOrUpdateFAQ error:", error);
    return { status: false, success: "FAQ save failed" };
  }
}
export async function deleteFAQ(faq_id) {
  try {
    const fd = new FormData();
    fd.append("faq_id", faq_id);

    const res = await axios.post(`${apiBaseUrl}profile/faq_delete`, fd, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    return res.data;
  } catch (error) {
    console.error("deleteFAQ error:", error);
    return { status: false, success: "FAQ delete failed" };
  }
}
export async function getFAQList(profile_id, page_no = 0) {
  try {
    const fd = new FormData();
    fd.append("faq_profile", profile_id);
    fd.append("page_no", page_no);

    const res = await axios.post(`${apiBaseUrl}profile/faq_list`, fd, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    return res.data;
  } catch (error) {
    console.error("getFAQList error:", error);
    return { status: false, success: "FAQ list failed" };
  }
}
export async function updateFAQOrder(faq_id, faq_order) {
  try {
    const fd = new FormData();
    fd.append("faq_id", faq_id);
    fd.append("faq_order", faq_order);

    const res = await axios.post(`${apiBaseUrl}profile/faq_update_order`, fd, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    return res.data;
  } catch (error) {
    console.error("updateFAQOrder error:", error);
    return { status: false, success: "Order update failed" };
  }
}

export async function getProReport(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const res = await axios.post(`${apiBaseUrl}profile/get_web_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    return res.data;
  } catch (error) {
    console.error("updateFAQOrder error:", error);
    return { status: false, success: "Order update failed" };
  }
}


export async function createPage(user_id,username,timezone) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("username", username);
    fd.append("timezone", timezone);
    // 

    const res = await axios.post(`${apiBaseUrl}profile/new_profile`, fd, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    return res.data;
  } catch (error) {
    console.error("updateFAQOrder error:", error);
    return { status: false, success: "Order update failed" };
  }
}

export async function publishWeb(profile_id) {
  try {
    const fd = new FormData();
    fd.append("profile_id", profile_id);

    const response = await axios.post(`${apiBaseUrl}profile/publish_website`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getWebReport error:", error);
    return { status: false, type: "danger", success: "Failed to load website report" };
  }
}




